import { Children, type ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import FilterCheckbox, { FilterCheckboxProps } from './FilterCheckbox';
import {
  filterCheckboxListContainerStyles,
  filterCheckboxListTitleStyles,
} from './FilterCheckboxList.styled';

export interface FilterCheckboxListProps {
  title: string;
  children:
  | ReactElement<FilterCheckboxProps>[]
  | ReactElement<FilterCheckboxProps>;
  isLast?: boolean;
}

export interface FilterCheckboxListItem {
  label: string;
  value: string;
}

export default function FilterCheckboxList({
  title,
  children,
  isLast = false,
}: FilterCheckboxListProps) {
  return (
    <Box sx={filterCheckboxListContainerStyles(isLast)}>
      <Typography
        variant="body1"
        sx={filterCheckboxListTitleStyles}
        component="span"
      >
        {title}
      </Typography>
      {Children.map(children, (item) => (
        <FilterCheckbox key={item.props.filterValue.sys.id} {...item.props} />
      ))}
    </Box>
  );
}
